import styled from "styled-components";

export const HeaderContainer = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
align-items: stretch;
`;

export const HeaderInfo = styled.div`
display: flex;
flex-direction: column;
gap: 8px;
align-self: flex-start;
`;

export const HeaderActions = styled.div`
display: flex;
align-self: flex-start;
position: relative;
& > .add-menu {
position: absolute;
top: 100%;
right: 0;
z-index: 1000;
}
`;


